import type {
  Flight,
  RawTourFlight,
  TourFlightDirection,
  TourFlightLocation,
  Transport,
} from './model'

const getLocationName = (location?: TourFlightLocation) => location?.code || ''

const getLocationCode = (location?: TourFlightLocation) => location?.title || ''

const toBagWeight = (weight: number | null | undefined) =>
  weight != null ? String(weight) : ''

const mapDirectionToTransport = (
  directionSegments: TourFlightDirection,
  directionIndex: number,
): Transport | null => {
  const firstSegment = directionSegments[0]
  const lastSegment = directionSegments[directionSegments.length - 1]

  if (!firstSegment || !lastSegment) {
    return null
  }

  const totalDuration = directionSegments.reduce(
    (sum, segment) => sum + (segment.duration || 0),
    0,
  )

  return {
    departure: [
      {
        stateKey: '',
        state: firstSegment.dep.country.title || '',
        townKey: '',
        town: getLocationName(firstSegment.dep.city),
        portKey: '',
        port: getLocationName(firstSegment.dep.city),
        portAlias: getLocationCode(firstSegment.dep.city),
        time: firstSegment.dep.time || '',
      },
    ],
    arrival: [
      {
        stateKey: '',
        state: lastSegment.arr.country.title || '',
        townKey: '',
        town: getLocationName(lastSegment.arr.city),
        portKey: '',
        port: getLocationName(lastSegment.arr.city),
        portAlias: getLocationCode(lastSegment.arr.city),
        time: lastSegment.arr.time || '',
      },
    ],
    datebeg: firstSegment.dep.date_time || '',
    dateend: lastSegment.arr.date_time || '',
    name: firstSegment.flight || '',
    class_: firstSegment.class_ || '',
    direction: String(directionIndex),
    transportCompany: firstSegment.carrier.title || '',
    durationMinutes: String(totalDuration),
    logo_url: firstSegment.carrier.logo_url || '',
    cbaggage: {
      weight: toBagWeight(firstSegment.luggage.weight),
      weight_unit: 'kg',
    },
    baggage: {
      weight: toBagWeight(firstSegment.baggage.weight),
      weight_unit: 'kg',
    },
    details: [
      {
        detail: directionSegments.map((segment) => ({
          class_: segment.class_ || '',
          fly_duration_min: String(segment.duration || 0),
          departure_airport_name: getLocationName(segment.dep.city),
          arrival_airport_name: getLocationName(segment.arr.city),
          flight_number: segment.flight || '',
          depart_time: segment.dep.time || '',
          arrival_time: segment.arr.time || '',
          departure_airport_code: getLocationCode(segment.dep.city),
          arrival_airport_code: getLocationCode(segment.arr.city),
          depart_datetime: segment.dep.date_time || '',
          arrival_datetime: segment.arr.date_time || '',
          full_marketing_airline: segment.carrier.title || '',
        })),
      },
    ],
  }
}

export const mapRawTourFlightToDisplayFlight = (
  rawFlight: RawTourFlight | null | undefined,
): Flight | null => {
  if (!rawFlight?.length) {
    return null
  }

  const transport = rawFlight
    .map((directionSegments, directionIndex) =>
      mapDirectionToTransport(directionSegments, directionIndex),
    )
    .filter((item): item is Transport => item != null)

  if (!transport.length) {
    return null
  }

  return { transport }
}
